module.exports = __webpack_public_path__ + "img/calendar-grey24.aedbed3a.svg";